import { render, staticRenderFns } from "./ossForm.vue?vue&type=template&id=783000a0&scoped=true"
import script from "./ossForm.vue?vue&type=script&lang=js"
export * from "./ossForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783000a0",
  null
  
)

export default component.exports